import React from 'react';
import Message, {getMessage} from '../../../components/common/Message';

//@ts-ignore
import styles from './CreatorCodeSection.pcss';

const CODES = {
    linkTitle: 'epic.affiliate.settings.link_title',
    linkDesc: 'epic.affiliate.settings.link_body',
    linkTitleV2: 'epic.affiliate.settings.link_title.v2',
    linkDescV2: 'epic.affiliate.settings.link_body.v2',
    changeCreatorCode: 'epic.affiliate.ccss.changeRedirect'
};

export interface CreatorCodeSectionProps {
    configState: Record<string, any>;
    messages: Record<string, string>;
    creatorCode: string;
}

const CreatorCodeSection: React.FC<CreatorCodeSectionProps> = ({
    configState,
    messages,
    creatorCode = 'N/A'
}) => {
    const {quickLinks = {}, enableCodeSelfService = false} = configState;
    let formattedText;

    if (enableCodeSelfService) {
        formattedText = getMessage(messages, CODES.changeCreatorCode, [
            quickLinks.changeCreatorCode
        ]);
    } else {
        formattedText = getMessage(messages, CODES.linkDescV2, [quickLinks.howToChangeCreatorCode]);
    }

    return (
        <div className={styles.section}>
            <div className={styles.title}>
                <Message code={CODES.linkTitleV2} />
            </div>
            <div
                className={styles.link}
                dangerouslySetInnerHTML={{
                    __html: formattedText
                }}
            />
            <div className={styles.box} key={creatorCode}>
                <span className={styles.boxContent}>{creatorCode}</span>
            </div>
        </div>
    );
};

export default CreatorCodeSection;
